import React from 'react'

import FormStyle from 'common/styles/forms.css'
import CommonStyle from 'common/styles/common.css'

import Style from '../styles/tooltip.css'

class YbSearch extends React.Component {
  constructor(props) {
    super(props);
  }

  searchTextChange(event) {
    this.props.onChange(event.target.value);
  }

  clearText() {
    this.props.onChange('');
  }

  render() {
    var placeholder = this.props.placeholder;
    var searchText = this.props.value;

    return (
      <div className={FormStyle.inputGroup}>
        <div className={`${FormStyle.form} ${FormStyle.formNoPadding}`}>
          <input value={searchText} type="text" placeholder={placeholder} onChange={this.searchTextChange.bind(this)}/>
        </div>
        <span
          onClick={this.clearText.bind(this)}
          className={`${FormStyle.clearButton} ${searchText ? FormStyle.clearButtonVisible : ''}`}
          >
          <i className="fa fa-times"></i>
        </span>
      </div>
    )
  }
}

module.exports = YbSearch;
